// extracted by mini-css-extract-plugin
module.exports = {"MainPageSubtitleWrapper":"MainPageSubtitle_MainPageSubtitleWrapper__2ytpi","Big":"MainPageSubtitle_Big__289Zs","AnimatedText":"MainPageSubtitle_AnimatedText__jdFhz"};